import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import SubscriptionPlanCard from './SubscriptionPlanCard'
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents'
import { analyticsLog } from 'services/analytics'
import CurrentMembershipCard from '../CurrentMembershipCard'
import MembershipSupportBanner from '../MembershipSupportBanner'

const TrialPricing: React.FC<{ onCancelMembership?: () => void, onProceedToCheckout?: (planId: string | number, frequency: string) => void }> = ({ onCancelMembership, onProceedToCheckout }) => {

    const plansData = useSelector((state: RootState) => state.membershipState.subscription_plans.data)
    const membershipData = useSelector((state: RootState) => state.membershipState.membership.data)

    const activePlan = membershipData?.active_plan;

    const plans = plansData?.plans ?? [];

    const trialPlans = plans.filter((plan) => plan.frequencies?.weekly?.is_trial);

    const freePlan = plansData?.free_plan ?? null;

    const featuredPlan = plans.find((plan) => plan.featured || plan.id === 7);

    const sortedPlans = useMemo(() => {
        let sorted_plans = [];
        if (freePlan) sorted_plans.push(freePlan);
        if (featuredPlan) sorted_plans.push({ ...featuredPlan, featured: true });
        if (trialPlans.length > 0) sorted_plans.push(...(trialPlans.filter((plan) => !sorted_plans.map((p) => p.id).includes(plan.id))));
        return sorted_plans;
    }, [trialPlans, freePlan, featuredPlan])

    useEffect(() => {
        analyticsLog(ANALYTICS_EVENTS.SUBSCRIPTION_TRIAL_VIEW)
    }, [])

    const isActivePaidPlan = useMemo(() => {
        return !(activePlan?.plan_frequency?.is_trial) && !activePlan?.plan?.default;
    }, [activePlan]);

    return (
        <div className='trial-pricings'>
            <div className="trial-header position-relative">
                <div className="radial-blur"></div>
                <div className="trial-badge">
                    FREE TRIAL
                    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                        <circle cx="2" cy="2" r="2" fill="#C0FF90" />
                    </svg>
                    NO CREDIT CARD REQUIRED
                </div>
                <div className="trial-header-content">
                    <h1 className="trial-header-title mt-4 mb-0">PICK YOUR PLAN</h1>
                    <h1 className="trial-header-title gradient-text">Try it free for 7 days.</h1>
                    <p className="trial-header-description mt-2">Choose the plan that fits your brand. You get full access  for 7 days absolutely free. We'll remind you before it ends.</p>
                </div>
            </div>

            {
                (isActivePaidPlan) && <div className='container mt-4'><CurrentMembershipCard onCancelMembership={onCancelMembership} onProceedToCheckout={onProceedToCheckout} /></div>
            }
            <div className="subscription-plans-wrapper">
                <h1 className="plan-header-title">CHOOSE YOUR FREE TRIAL</h1>
                <div className="container py-5">
                    <div className="row g-4 justify-content-center">
                        {
                            sortedPlans.map((plan) => {
                                return (
                                    <div className="col-md-4">
                                        <SubscriptionPlanCard onCancelMembership={onCancelMembership} onProceedToCheckout={onProceedToCheckout} plan={plan} frequency='weekly' isActive={activePlan?.membership_plan_id === plan.id} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="pb-5">
                    <MembershipSupportBanner />
                </div>
            </div>
        </div>
    )
}

export default TrialPricing